import { css } from 'styled-system/css';

export const bettingSettingModalStyle = {
	modal: css({
		base: {
			'& .modal__container': {
				maxW: '354px',
				minW: 'auto'
			}
		}
	}),
	stakeWrapper: css({
		base: {
			
		},
		_mars: { 
			p: '12px 12px 0 12px',
			fontSize: '12px',
			fontWeight: 500,
		}
	}),
	stakeContent: css({
		_mars: { 
			border: '1px solid {colors.brand.500_12}',
			borderRadius: '6px', 
		}
	}),
	stakeItem: css({
		base: {

		},
		_mars: { 
		},
	}),
	scrollbar: css({
		base: {
			color: 'var(--body-text)',
			display: 'flex',
			flexDirection: 'column',
			'& .settings__group': {
				bgColor: 'var(--s400)',
			}
		},
		_mars: {
			'& .settings__group': {
				bgColor: 'inherit',
			}
		}
	}),
	title: css({
		base: {
			h: '42px',
			lineHeight: '42px',
			fontSize: '14px',
			bgColor: 'var(--s400)',
			fontWeight: 500,
			color: 'var(--body-text)',
			_ltr: {
				pl: '12px',
			},
			_rtl: {
				pr: '12px',
			},
		},
		_mars: {
			h: '36px',
			lineHeight: '36px',
			fontSize: '12px',
			color: 'setBettingsModal.title',
		}
	})
}